"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _dashboardTabTypes = _interopRequireDefault(require("./dashboard-tab-types"));

var _tabSelector = _interopRequireDefault(require("../../common/tab-selector/tab-selector"));

const DashboardTabs = props => {
  const {
    onChange,
    selectedTab,
    children
  } = props;
  return /*#__PURE__*/_react.default.createElement(_tabSelector.default, {
    className: "dashboard-tabs",
    selectedTab: selectedTab,
    onChange: onChange,
    tabs: [{
      value: _dashboardTabTypes.default.DRAFTS,
      title: 'Drafts'
    }, {
      value: _dashboardTabTypes.default.PUBLISHED,
      title: 'Published'
    }]
  }, children);
};

DashboardTabs.propTypes = {
  onChange: _propTypes.default.func.isRequired,
  selectedTab: _propTypes.default.oneOf(Object.values(_dashboardTabTypes.default)),
  children: _propTypes.default.node
};
DashboardTabs.defaultProps = {
  selectedTab: _dashboardTabTypes.default.DRAFTS,
  children: null
};
var _default = DashboardTabs;
exports.default = _default;